import { render } from "./SaveReportDialog.vue?vue&type=template&id=5b4ccd57"
import script from "./SaveReportDialog.vue?vue&type=script&lang=js"
export * from "./SaveReportDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__